import { lazyWithChunkReload } from "../../shared/lib/chunk-load-recovery";

export const CommunicationPage = lazyWithChunkReload(() =>
  import("./pages/homepage").then((m) => ({ default: m.Homepage }))
);

export const CommunicationReportsPage = lazyWithChunkReload(() =>
  import("./pages/reports").then((m) => ({ default: m.Reports }))
);

export const CommunicationCertificationPagesPage = lazyWithChunkReload(() =>
  import("./pages/climatepartner-certification").then((m) => ({ default: m.ClimatepartnerCertification }))
);

export const CommunicationCreateCertificationPage = lazyWithChunkReload(() =>
  import("./pages/climatepartner-certification/create").then((m) => ({ default: m.CreateCertificationPage }))
);

export const CommunicationEditCertificationPage = lazyWithChunkReload(() =>
  import("./pages/climatepartner-certification/edit").then((m) => ({ default: m.EditCertificationPage }))
);

export const CommunicationCustomerInformationPage = lazyWithChunkReload(() =>
  import("./pages/customer-information").then((m) => ({ default: m.CustomerInformation }))
);

export const CommunicationTransparencyPage = lazyWithChunkReload(() =>
  import("./pages/transparency-page").then((m) => ({ default: m.TransparencyPage }))
);
